var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientId)?_c('ag-grid-server-side',{attrs:{"column-defs":_vm.columnDefs,"server-side-datasource":_vm.serverSideDatasource}}):_c('p',[_vm._v("No client ID is associated with this district")])}
var staticRenderFns = []

export { render, staticRenderFns }